import React, {useState} from 'react'
import Header from '../../components/headers/Header'
import { MiFooter } from '../../components/footer/MiFooter'
import { ContentBodyUserFeedback } from '../../components/UserFeedback/ContentBodyUserFeedback'
import './UserFeedback.css'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'

export const UserFeedback = () => {
    const [MenuLateralAux, setMenuLateralAux] = useState();


    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }
    return (
        <>
            <div className='UserFeedback' >
                <div className='headerUserFeedback'>
                    <Header chageMenuLateralAux={chageMenuLateralAux} />
                </div>
                <div className="bodyUserFeedback">
                    <ContentBodyUserFeedback
                     MenuLateralAux={MenuLateralAux}
                        chageMenuLateralAux={chageMenuLateralAux} 
                        />
                </div>
                <div className='footerReservarServicio'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}
